// Third-party Library
import { Modal, Button, Input } from "antd"

// components
import { PrimaryButton } from "../../../Decoration/Button"
import SVG from "../../../SVG"
import { useState } from "react"

// style 
// import styles from './index.module.css'

const ModalFooter = ({ onClick, onCancel, loading }) => {
    return (
        <div className={'v-center'} style={{ gap: '1em' }}>
            <Button onClick={onCancel} style={{ padding: '1.6em', backgroundColor: '#ED5B57', color: '#fff'}}>Cancel</Button>
            <PrimaryButton onClick={onClick} loading={loading} mode='primary' style={{ padding: '1.6em'}}>Yes</PrimaryButton>
        </div>
    )
}

/**
 * 
 * Main render
 * 
 */
export const ModalRemark = ({
    onOk = () => {},
    open = false,
    onCancel = () => {},
    loading = false
}) => {

    const [ remark, setRemark ] = useState('')

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            closable={false}
            footer={<ModalFooter onCancel={onCancel} loading={loading} onClick={() => onOk(remark)} />}
            width={400}
        >
            <div style={{ padding: '.2em .5em 0 .2em', textAlign: 'center' }}>
                <SVG 
                    name={`warning-blue`}
                    viewBox="0 0 35 35" 

                    fill="none" 
                    size="50"
                />
                <div style={{ textAlign: 'left'}}>
                    <h3>Remarks</h3>
                    <Input.TextArea style={{ height: 150, resize: 'none' }} onChange={e => setRemark(e.target.value)} />
                </div>
            </div>
        </Modal>
    )
}